import React from "react";
import ListKpiController from "./ListKpiController";

export default function ListKpiStandardController() {

    return (
        <ListKpiController
            categoria={1}
        />
    );
}
